import {gsap} from "gsap";

const Compare = {
    init() {
        this.el = $('[page="compare"]');
        if (!this.el.length) return;

        this.cars = this.el.find('.car');
        this.expander = this.el.find('.expander');
        this.slider = this.el.find('.slider');

        this.bind();
        this.initSlider();

        setTimeout(() => {
            this.equalHeights();
        }, 100)
    },

    equalHeights() {
        let hTop = 0;
        let hBottom = 0;
        this.cars.each((i, el) => {
            hTop = Math.max(hTop, $(el).find('.info').outerHeight())
            hBottom = Math.max(hBottom, $(el).find('.details').outerHeight())
        })
        this.cars.find('.info').css({height: hTop});
        this.cars.find('.details').css({height: hBottom});
    },

    bind() {
        this.expander.click((evt) => {
            evt.stopPropagation();
            const el = $(evt.currentTarget);

            if (this.el.is('.expanded')) {
                this.hide(el);
            } else {
                this.show(el)
            }
            return false;
        });
    },

    show(el) {
        const expander = this.cars.find('.equipment .expander');
        const holder = this.cars.find('.equipment .holder');

        this.el.addClass('expanded');
        expander.addClass('expanded').text(window.T.STL.collapse_equipment);
        gsap.set(holder, {height: 'auto'})
        gsap.from(holder, {height: 0});
    },

    hide(el) {
        const expander = this.cars.find('.equipment .expander');
        const holder = this.cars.find('.equipment .holder');

        this.el.removeClass('expanded');
        expander.removeClass('expanded').text(window.T.STL.expand_equipment);
        gsap.to(holder, {height: 0})
    },

    initSlider() {
        this.slider.addClass('owl-carousel');
        this.slider.owlCarousel({
            "smartSpeed": 750,
            "loop": false,
            "autoWidth": false,
            "nav": true,
            "dots": false,
            "progress": false,
            "counter": false,
            "margin": 0,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""],

            "responsive": {
                "1280": {
                    "items": 4
                },
                "1000": {
                    "items": 3
                },
                "640": {
                    "items": 2
                }
            }
        });
    }
}
export default Compare;